import { Box } from '@mui/material';
import type { ReactNode } from 'react';
import { pageContentContainer, pageGutter, type PageContentWidth } from './pageContent';

export type PageBodyProps = {
  children: ReactNode;
  width?: PageContentWidth;
  testId?: string;
  fill?: boolean;
};

export function PageBody({ children, width = 'wide', testId, fill = false }: PageBodyProps) {
  return <Box data-testid={testId} sx={{ ...pageContentContainer(width), flex: fill ? '1 1 auto' : undefined, minHeight: 0 }}>
    <Box data-testid="page-body-inner" sx={{ width: '100%', px: pageGutter, pb: pageGutter, boxSizing: 'border-box', height: fill ? '100%' : undefined, minHeight: 0 }}>
      <Box data-testid="page-body-content" sx={{ width: '100%', height: fill ? '100%' : undefined, minHeight: 0 }}>
        {children}
      </Box>
    </Box>
  </Box>;
}
